module.exports = __webpack_public_path__ + "static/extra_2_mobile-e0e23794ffb4e61960dcee3ab1d3b338.jpg";